// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__4VHcr","label":"Radio_label__FlfIa"};